import { render, staticRenderFns } from "./ShowOrder.vue?vue&type=template&id=a2687046&scoped=true"
import script from "./ShowOrder.vue?vue&type=script&lang=js"
export * from "./ShowOrder.vue?vue&type=script&lang=js"
import style0 from "./ShowOrder.vue?vue&type=style&index=0&id=a2687046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2687046",
  null
  
)

export default component.exports